export default {
    REPORT: 'report',
    TAG: 'tag',
    TRACKED_KEYWORD: 'keyword',
    TRACKED_KEYWORDS: 'keyword(s)',
    TRACKING: 'tracking',
};
